import React from "react";
import { useHistory } from "react-router-dom";

function PrivacyPolicyPage() {
  const history = useHistory();

  const handleGoBack = () => {
    history.goBack();
  };

  return (
    <div className="privacy-policy fade-in">
      <div className="privacy-header">
        <button className="back-button button-transition" onClick={handleGoBack}>
          ← Back
        </button>
        <h1 className="privacy-title">TERMS OF SERVICE</h1>
      </div>
      <p className="privacy-date">Effective Date: July 21, 2025</p>

      <div className="privacy-content form-transition">
        <section className="privacy-section section-transition">
          <h2>1. Introduction</h2>
          <p>
            Welcome to Ubuck.org ("Ubuck," "we," "our," or "us"). Ubuck provides web‑based classroom–management tools that help schools run an incentive economy using "UBucks" points, auctions, raffles, and a teacher store (collectively, the "Services").

            These Terms of Service (the "Agreement") form a binding contract between Ubuck and every individual or entity that accesses the Services— including schools, districts, teachers, administrators, students, and parents (collectively, "Users" or "you"). By accessing or using the Services (or by clicking an "I Agree" or similar button), you acknowledge that you have read, understood, and agree to be bound by this Agreement and by our Privacy Policy. IF YOU DO NOT AGREE, YOU MAY NOT USE THE SERVICES.
          </p>
        </section>

        <section className="privacy-section section-transition">
          <h2>2. Eligibility & Age Requirements</h2>
          <ol>
            <li>
              Schools as Gatekeepers. Ubuck is designed for U.S. schools serving 6th–12th grades (approx. ages 11‑19). Each school or district that creates an account ("School") represents that it has authority to enter this Agreement and to act as the parent's agent for students under 13 in accordance with the Children's Online Privacy Protection Act ("COPPA").
            </li>
            <li>
              Students Under 13. For any student who is younger than 13 years old, the School (not Ubuck) must secure verifiable parental consent before that student may use the Services.
            </li>
            <li>
              Students 13‑17. Students aged 13‑17 may only use the Services with their School's permission and supervision.
            </li>
            <li>
              Account Responsibility. You are responsible for all activity that occurs under your credentials. Keep passwords secure and notify us immediately of any unauthorized use.
            </li>
          </ol>
        </section>

        <section className="privacy-section section-transition">
          <h2>3. Changes to the Services or Terms</h2>
          <p>We may modify the Services or this Agreement at any time. If we make material changes, we will notify the primary School contact by email 30 days in advance. Your continued use after the effective date of any change constitutes acceptance of the revised terms.</p>
        </section>

        <section className="privacy-section section-transition">
          <h2>4. User Conduct—Prohibited Activities</h2>
          <p>
            You agree NOT to:
          </p>
          <ul>
            <li>
              copy, scrape, or distribute any part of the Services except as expressly allowed;
            </li>
            <li>
              interfere with security features, breach or probe our systems, or upload malware;
            </li>
            <li>
              use automated scripts (bots, spiders) that place an unreasonable load on our servers;
            </li>
            <li>
              collect personal information from other Users, except as permitted for School purposes;
            </li>
            <li>
              impersonate another person or misrepresent your affiliation;
            </li>
            <li>
              use the Services for commercial solicitation or advertising;
            </li>
            <li>
              violate any applicable law or regulation (including FERPA, COPPA, or state student‑privacy laws).
            </li>
          </ul>
          <p>
            We may suspend or terminate access for violations, without notice.
          </p>
        </section>

        <section className="privacy-section section-transition">
          <h2>5. Ownership & Intellectual‑Property Rights</h2>
          <ol>
            <li>
              Ubuck Content. Except for Student Data (defined below), all software, text, images, graphics, logos, and other materials in the Services ("Ubuck Content") are the exclusive property of Ubuck or its licensors and are protected by U.S. and international intellectual‑property laws. Ubuck grants you a limited, revocable, non‑transferable license to access and use Ubuck Content solely to operate the Services for educational purposes.
            </li>
            <li>
              Student Data. "Student Data" means information directly related to an identifiable current or former student that is maintained by a School. The School owns Student Data and remains responsible for it. Ubuck will use Student Data only as permitted by this Agreement and our Privacy Policy, solely to provide and improve the Services, and will never sell Student Data.
            </li>
            <li>
              <p>User Submissions (Bug Reports, Feature Requests, Etc.).</p>
              <ol>
                <li>
                  Definition. "Submission" means any idea, suggestion, feedback, bug report, feature request, message, file, or other content you upload, post, or transmit to the Services that is not Student Data.
                </li>
                <li>
                  Assignment of Rights. You irrevocably assign to Ubuck all right, title, and interest in and to every Submission—including any associated intellectual‑property rights—without compensation of any kind. To the extent an assignment is ineffective, you grant Ubuck a perpetual, irrevocable, worldwide, royalty‑free, sublicensable license to use, reproduce, modify, publish, distribute, and create derivative works from the Submission for any purpose.
                </li>
                <li>
                  No Expectation of Payment. You acknowledge and agree that you are not entitled to any compensation, attribution, or reimbursement for any Submission, including but not limited to bug reports or feature requests.
                </li>
              </ol>
            </li>
          </ol>
        </section>

        <section className="privacy-section section-transition">
          <h2>6. Privacy & Student‑Data Protection</h2>
          <p>
            We take privacy seriously. Our collection, use, and disclosure of personal information (including Student Data) are described in our Privacy Policy, which is incorporated by reference. Among other things, we:
          </p>
          <ul>
            <li>
              store Student Data in the United States
            </li>
            <li>
              process Student Data only on documented School instructions;
            </li>
            <li>
              delete or de‑identify Student Data within 60 days of a verified deletion request from the School.
            </li>
          </ul>
        </section>

        <section className="privacy-section section-transition">
          <h2>7. Service Changes, Data Retention & Deletion</h2>
          <p>
            We may add, modify, or discontinue features at any time. Ubuck may delete data stored on its servers (other than Student Data, which will be deleted only at the School's direction) without liability or notice. Schools must maintain their own local backups.
          </p>
        </section>

        <section className="privacy-section section-transition">
          <h2>8. Third‑Party Links & Services</h2>
          <p>
            The Services may link to third‑party sites or integrate third‑party tools. Ubuck is not responsible for third‑party content, privacy practices, or failures. Your dealings with third parties are solely between you and them.
          </p>
        </section>

        <section className="privacy-section section-transition">
          <h2>9. Indemnification</h2>
          <p>
            You agree to defend, indemnify, and hold harmless Ubuck, its affiliates, officers, agents, and employees from any claim, loss, liability, or expense (including attorneys' fees) arising out of or relating to:
            <ul>
              <li>
                your use of the Services;
              </li>
              <li>
                your violation of this Agreement or of any law;
              </li>
              <li>
                any Submission you provide; or
              </li>
              <li>
                any interaction between you and another User.
              </li>
            </ul>
          </p>
        </section>

        <section className="privacy-section section-transition">
          <h2>10. Warranty Disclaimer</h2>
          <p>
            THE SERVICES ARE PROVIDED "AS IS" AND "AS AVAILABLE." UBuck DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON‑INFRINGEMENT. WE DO NOT GUARANTEE THAT THE SERVICES WILL BE UNINTERRUPTED, ERROR‑FREE, OR SECURE.
          </p>
        </section>

        <section className="privacy-section section-transition">
          <h2>11. Limitation of Liability</h2>
          <p>
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, UBUCK WILL NOT BE LIABLE FOR INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, EXEMPLARY, OR PUNITIVE DAMAGES OR FOR ANY LOSS OF PROFITS, DATA, OR GOODWILL, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. OUR TOTAL LIABILITY FOR ANY CLAIM ARISING OUT OF OR RELATING TO THE SERVICES WILL NOT EXCEED THE GREATER OF (A) ONE HUNDRED U.S. DOLLARS ($100) OR (B) THE AMOUNT YOU PAID US IN THE TWELVE MONTHS PRECEDING THE EVENT GIVING RISE TO THE CLAIM. SOME JURISDICTIONS DO NOT ALLOW CERTAIN LIMITATIONS; THOSE LIMITATIONS MAY NOT APPLY TO YOU.
          </p>
        </section>

        <section className="privacy-section section-transition">
          <h2>12. Governing Law & Dispute Resolution</h2>
          <p>
            This Agreement is governed by the laws of the State of California, without regard to conflict‑of‑law rules. You agree to submit to the personal and exclusive jurisdiction of the state and federal courts located in Alameda County, California for all disputes arising out of or relating to the Services or this Agreement.
          </p>
        </section>

        <section className="privacy-section section-transition">
          <h2>13. Miscellaneous</h2>
          <ul>
            <li>
              Entire Agreement. This Agreement, together with our Privacy Policy and any Additional Terms we publish for Schools, constitutes the entire agreement between you and Ubuck.
            </li>
            <li>
              Severability. If any provision is held invalid, the remainder will continue in full force.
            </li>
            <li>
              No Waiver. Our failure to enforce any right is not a waiver of future enforcement.
            </li>
            <li>
              Assignment. You may not assign your rights under this Agreement; we may assign ours without restriction.
            </li>
            <li>
              Survival. Sections 5 (Ownership), 6 (Privacy), 7 (Data Retention), 9 (Indemnification), 10 (Disclaimer), 11 (Limitation of Liability), 12 (Governing Law), and 13 (Miscellaneous) survive termination.
            </li>
          </ul>
        </section>

        <p>
          Questions?
          Email us at <a href="mailto:SchoolBucks@proton.me" className="link-transition">SchoolBucks@proton.me</a>. Thanks for helping students learn financial literacy—one UBuck at a time!
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
